import { SolNavbar, SolNavbarItem, SolRouteId } from '@sol/components';
import { SolIcon } from '@sol/icons';
import { PrototypeRouteId } from '../../models/prototype-route-id';

// As the asset-details redesign: a kind's list entry opens a sample asset; its detail child names the asset and
// shows the tabs in the topbar
const assetItem = (
  listRouteId: SolRouteId,
  detailRouteId: SolRouteId,
  tabs: [SolRouteId, string][],
  displayName: string,
  icon: SolIcon,
): SolNavbarItem =>
  SolNavbarItem.of(listRouteId, {
    displayName,
    icon,
    showChildrenInNavbar: false,
    children: [
      SolNavbarItem.of(detailRouteId, {
        displayName: 'asm-prototype.redirect-duplicates.asset.name',
        nameParams: ['assetName'],
        showChildrenAsTabs: true,
        children: tabs.map(([routeId, tabName]) => SolNavbarItem.of(routeId, { displayName: tabName })),
      }),
    ],
  });

/** The tracker list, with the observation page as its hidden child so the breadcrumb reads Tracker › subject. */
export const redirectDuplicatesNavbar: SolNavbar = {
  menu: [
    SolNavbarItem.of(PrototypeRouteId.app_redirect_duplicates, {
      displayName: 'Tracker',
      icon: SolIcon.asm_tracker,
      showChildrenInNavbar: false,
      children: [
        SolNavbarItem.of(PrototypeRouteId.redirect_duplicates_observation, {
          displayName: 'asm-prototype.redirect-duplicates.observation.name',
          nameParams: ['observationName'],
        }),
      ],
    }),
    assetItem(
      PrototypeRouteId.redirect_duplicates_websites,
      PrototypeRouteId.redirect_duplicates_website,
      [
        [PrototypeRouteId.redirect_duplicates_website_overview, 'Overview'],
        [PrototypeRouteId.redirect_duplicates_website_findings, 'Findings'],
      ],
      'Website',
      SolIcon.asm_websites,
    ),
    assetItem(
      PrototypeRouteId.redirect_duplicates_domains,
      PrototypeRouteId.redirect_duplicates_domain,
      [
        [PrototypeRouteId.redirect_duplicates_domain_overview, 'Overview'],
        [PrototypeRouteId.redirect_duplicates_domain_findings, 'Findings'],
      ],
      'Domain',
      SolIcon.asm_domains,
    ),
  ],
  system: [],
  account: [
    SolNavbarItem.of(PrototypeRouteId.account_section1, {
      children: [
        SolNavbarItem.of(PrototypeRouteId.account_preferences, {
          displayName: 'Preferences',
        }),
      ],
    }),
    SolNavbarItem.of(PrototypeRouteId.account_section2, {
      children: [SolNavbarItem.of(PrototypeRouteId.account_logout, { displayName: 'Logout' })],
    }),
  ],
};
